<mat-card class="d-inline-block">
  <div class="text-center p-3">
    <h4>{{ 'Common.NotFound' | translate }}</h4>

    <div class="mt-3">
      <img src="assets/images/icons/emoticons/sad.svg">
    </div>
  </div>
</mat-card>